import { Typography, ContentDisplay, Box } from '../../base';
import { PageContainer, Header, Content, PDFWrapper, LogoImage, HeaderContent } from './TermsAndServicesPage.styles';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LANGUAGES } from '../../common';
import termsEnglish from '../../../public/assets/pargoda_terms_english.html?raw';
import termsHebrew from '../../../public/assets/pargoda_terms_hebrew.html?raw';

const TermsAndServicesPage = () => {
    const [searchParams] = useSearchParams();

    const { htmlContent, isRTL } = useMemo(() => {
        // Check for lan query parameter (case-insensitive)
        const language = searchParams.get('lan')?.toLowerCase();
        const isHebrew = language === LANGUAGES.HE.toLowerCase();
        
        // Load the appropriate HTML content
        const content = isHebrew ? termsHebrew : termsEnglish;
        
        return {
            htmlContent: content,
            isRTL: isHebrew
        };
    }, [searchParams]);

    const pageTitle = isRTL ? 'תנאי שימוש - PARGODA' : 'Terms and Conditions - Pargoda';

    return (
        <Box dir={isRTL ? 'rtl' : 'ltr'}>
            <PageContainer>
                <Header>
                    <LogoImage src="/assets/fullTextLogo.svg" alt="Pargoda Logo" />
                    <HeaderContent>
                        <Typography variant="h4" component="h1">
                            {pageTitle}
                        </Typography>
                    </HeaderContent>
                </Header>
                <Content>
                    <PDFWrapper>
                        <ContentDisplay content={htmlContent} />
                    </PDFWrapper>
                </Content>
            </PageContainer>
        </Box>
    );
};

export default TermsAndServicesPage;
